import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Tours } from "@/components/site/Tours";
import { Yachts } from "@/components/site/Yachts";
import { Manifesto } from "@/components/site/Manifesto";
import { Fleet } from "@/components/site/Fleet";
import { Booking } from "@/components/site/Booking";
import { Footer } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { BookingProvider } from "@/components/site/BookingContext";

export default function Home() {
  return (
    <SmoothScroll>
      <BookingProvider>
        <div className="grain bg-[#0A0A0C] text-[#F9F9F9]" data-testid="home-page">
          <Header />
          <main>
            <Hero />
            <Marquee />
            <Tours />
            <Yachts />
            <Manifesto />
            <Fleet />
            <Booking />
          </main>
          <Footer />
        </div>
      </BookingProvider>
    </SmoothScroll>
  );
}
